import { APP_INITIALIZER, EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { OidcSecurityService, provideAuth } from 'angular-auth-oidc-client';
import { catchError, of, switchMap } from 'rxjs';
import { getAuthConfig } from './auth.config';

export function provideOidcAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAuth(getAuthConfig()),
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const oidcService = inject(OidcSecurityService);
        return () =>
          oidcService.checkAuth().pipe(
            switchMap(({ isAuthenticated }) => {
              if (isAuthenticated) return of(null);
              // Access token expiró pero el refresh token puede ser válido.
              // forceRefreshSession() obtiene tokens nuevos silenciosamente.
              return oidcService.forceRefreshSession().pipe(catchError(() => of(null)));
            }),
            catchError(() => of(null)),
          );
      },
      multi: true,
    },
  ]);
}
